<template>
  <div>
    <only-site-card :com_data="com_data">
      <template v-slot:item_edit>
        <ValidationObserver ref="observer">
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">外部リンクボタン</span>
                <p class="mini">
                  セラピストの詳細ページにボタンを設置できます。最大10個まで設定可能です。テキストとURLの両方を入力してください。
                </p>
              </v-col>
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_text_1.text"
                      :rules="items.button_text_1.rules"
                    >
                      <v-text-field
                        ref="button_text_1"
                        v-model="cast_prop.button_text_1"
                        name="button_text_1"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_text_1.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_text_1.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_url_1.text"
                      :rules="items.button_url_1.rules"
                    >
                      <v-text-field
                        ref="button_url_1"
                        v-model="cast_prop.button_url_1"
                        name="button_url_1"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_url_1.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_url_1.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-row class="mt-6">
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_text_2.text"
                      :rules="items.button_text_2.rules"
                    >
                      <v-text-field
                        ref="button_text_2"
                        v-model="cast_prop.button_text_2"
                        name="button_text_2"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_text_2.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_text_2.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_url_2.text"
                      :rules="items.button_url_2.rules"
                    >
                      <v-text-field
                        ref="button_url_2"
                        v-model="cast_prop.button_url_2"
                        name="button_url_2"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_url_2.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_url_2.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-row class="mt-6">
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_text_3.text"
                      :rules="items.button_text_3.rules"
                    >
                      <v-text-field
                        ref="button_text_3"
                        v-model="cast_prop.button_text_3"
                        name="button_text_3"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_text_3.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_text_3.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_url_3.text"
                      :rules="items.button_url_3.rules"
                    >
                      <v-text-field
                        ref="button_url_3"
                        v-model="cast_prop.button_url_3"
                        name="button_url_3"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_url_3.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_url_3.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-row class="mt-6">
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_text_4.text"
                      :rules="items.button_text_4.rules"
                    >
                      <v-text-field
                        ref="button_text_4"
                        v-model="cast_prop.button_text_4"
                        name="button_text_4"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_text_4.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_text_4.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_url_4.text"
                      :rules="items.button_url_4.rules"
                    >
                      <v-text-field
                        ref="button_url_4"
                        v-model="cast_prop.button_url_4"
                        name="button_url_4"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_url_4.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_url_4.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-row class="mt-6">
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_text_5.text"
                      :rules="items.button_text_5.rules"
                    >
                      <v-text-field
                        ref="button_text_5"
                        v-model="cast_prop.button_text_5"
                        name="button_text_5"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_text_5.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_text_5.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_url_5.text"
                      :rules="items.button_url_5.rules"
                    >
                      <v-text-field
                        ref="button_url_5"
                        v-model="cast_prop.button_url_5"
                        name="button_url_5"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_url_5.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_url_5.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-row class="mt-6">
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_text_6.text"
                      :rules="items.button_text_6.rules"
                    >
                      <v-text-field
                        ref="button_text_6"
                        v-model="cast_prop.button_text_6"
                        name="button_text_6"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_text_6.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_text_6.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_url_6.text"
                      :rules="items.button_url_6.rules"
                    >
                      <v-text-field
                        ref="button_url_6"
                        v-model="cast_prop.button_url_6"
                        name="button_url_6"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_url_6.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_url_6.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-row class="mt-6">
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_text_7.text"
                      :rules="items.button_text_7.rules"
                    >
                      <v-text-field
                        ref="button_text_7"
                        v-model="cast_prop.button_text_7"
                        name="button_text_7"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_text_7.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_text_7.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_url_7.text"
                      :rules="items.button_url_7.rules"
                    >
                      <v-text-field
                        ref="button_url_7"
                        v-model="cast_prop.button_url_7"
                        name="button_url_7"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_url_7.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_url_7.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-row class="mt-6">
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_text_8.text"
                      :rules="items.button_text_8.rules"
                    >
                      <v-text-field
                        ref="button_text_8"
                        v-model="cast_prop.button_text_8"
                        name="button_text_8"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_text_8.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_text_8.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_url_8.text"
                      :rules="items.button_url_8.rules"
                    >
                      <v-text-field
                        ref="button_url_8"
                        v-model="cast_prop.button_url_8"
                        name="button_url_8"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_url_8.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_url_8.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-row class="mt-6">
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_text_9.text"
                      :rules="items.button_text_9.rules"
                    >
                      <v-text-field
                        ref="button_text_9"
                        v-model="cast_prop.button_text_9"
                        name="button_text_9"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_text_9.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_text_9.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_url_9.text"
                      :rules="items.button_url_9.rules"
                    >
                      <v-text-field
                        ref="button_url_9"
                        v-model="cast_prop.button_url_9"
                        name="button_url_9"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_url_9.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_url_9.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-row class="mt-6">
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_text_10.text"
                      :rules="items.button_text_10.rules"
                    >
                      <v-text-field
                        ref="button_text_10"
                        v-model="cast_prop.button_text_10"
                        name="button_text_10"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_text_10.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_text_10.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.button_url_10.text"
                      :rules="items.button_url_10.rules"
                    >
                      <v-text-field
                        ref="button_url_10"
                        v-model="cast_prop.button_url_10"
                        name="button_url_10"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.button_url_10.text"
                        outlined
                        hint=""
                        persistent-hint
                        :counter="items.button_url_10.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </ValidationObserver>
      </template>
    </only-site-card>
  </div>
</template>

<script>
import {
  set,
  ref,
  reactive,
  toRefs,
  defineComponent,
} from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import utilFunc from "@/common/utilFunc.js";

export default defineComponent({
  props: ["com_data"],
  setup(props, ctx) {
    const CastPropsRepository = repositoryFactory.get("castProps");
    const state = reactive({
      errorElement: null,
      cast_prop: {},
      // 読み込み時データ保持(保存前比較用)
      keepData: {
        cast_prop: {},
      },
    });

    const items = {
      "button_text_1": { text: "1. ボタン名", rules: "max:50", counter: "50" },
      "button_url_1": {
        text: "1. リンク先URL",
        rules: "url|max:200",
        counter: "200",
      },
      "button_text_2": { text: "2. ボタン名", rules: "max:50", counter: "50" },
      "button_url_2": {
        text: "2. リンク先URL",
        rules: "url|max:200",
        counter: "200",
      },
      "button_text_3": { text: "3. ボタン名", rules: "max:50", counter: "50" },
      "button_url_3": {
        text: "3. リンク先URL",
        rules: "url|max:200",
        counter: "200",
      },
      "button_text_4": { text: "4. ボタン名", rules: "max:50", counter: "50" },
      "button_url_4": {
        text: "4. リンク先URL",
        rules: "url|max:200",
        counter: "200",
      },
      "button_text_5": { text: "5. ボタン名", rules: "max:50", counter: "50" },
      "button_url_5": {
        text: "5. リンク先URL",
        rules: "url|max:200",
        counter: "200",
      },
      "button_text_6": { text: "6. ボタン名", rules: "max:50", counter: "50" },
      "button_url_6": {
        text: "6. リンク先URL",
        rules: "url|max:200",
        counter: "200",
      },
      "button_text_7": { text: "7. ボタン名", rules: "max:50", counter: "50" },
      "button_url_7": {
        text: "7. リンク先URL",
        rules: "url|max:200",
        counter: "200",
      },
      "button_text_8": { text: "8. ボタン名", rules: "max:50", counter: "50" },
      "button_url_8": {
        text: "8. リンク先URL",
        rules: "url|max:200",
        counter: "200",
      },
      "button_text_9": { text: "9. ボタン名", rules: "max:50", counter: "50" },
      "button_url_9": {
        text: "9. リンク先URL",
        rules: "url|max:200",
        counter: "200",
      },
      "button_text_10": {
        text: "10. ボタン名",
        rules: "max:50",
        counter: "50",
      },
      "button_url_10": {
        text: "10. リンク先URL",
        rules: "url|max:200",
        counter: "200",
      },
    };

    const init = async () => {
      // cast_propにキーを設定
      for (let key in items) {
        set(state.cast_prop, key, null);
      }
      Object.keys(props.com_data.cast_prop).forEach(function (key) {
        set(state.cast_prop, key, props.com_data.cast_prop[key]);
      });
      // 読み込み時のデータを保持(保存前に比較するため)
      state.keepData.cast_prop = Object.assign({}, state.cast_prop);
    };

    init();

    // チェック処理
    const checkValid = async () => {
      // 事前チェック処理
      state.errorElement = null;
      const isValid = await ctx.refs.observer.validate();
      if (!isValid) {
        let item_name = "";
        Object.keys(ctx.refs.observer.errors).forEach(function (key) {
          if (ctx.refs.observer.errors[key].length > 0) {
            item_name = key;
            return;
          }
        });
        const errorKey = utilFunc.getKeyByItemText(items, item_name);
        if (errorKey == "lady_type") {
          state.errorElement = ctx.refs[errorKey][0].$el;
        } else {
          state.errorElement = ctx.refs[errorKey].$el;
        }
      }
      return isValid;
    };

    const setErrorFocus = async () => {
      setTimeout(() => {
        state.errorElement.scrollIntoView({
          block: "center",
        });
      }, 300);
    };

    // 保存処理
    const save = async () => {
      // 更新前と比べて差分があれば更新処理
      if (!utilFunc.compareObject(state.keepData.cast_prop, state.cast_prop)) {
        const prop_param = [];
        for (let key in state.cast_prop) {
          prop_param.push({
            cast_id: props.com_data.cast_id,
            key: props.com_data.prefix + "__" + key,
            value: state.cast_prop[key] ?? "",
          });
        }
        await CastPropsRepository.save_all({ cast_prop: prop_param })
          .then((response) => {
            if (response.data) {
              // データ追加OK
            }
          })
          .catch((error) => {
            throw (
              "ERROR:estama.vue/save CastPropsRepository.save_all (" +
              error +
              ")"
            );
          });
      }
      return true;
    };

    return {
      props,
      setting,
      items,
      ...toRefs(state),
      checkValid,
      setErrorFocus,
      save,
    };
  },
});
</script>

<style scoped></style>
